import React from "react";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { Scrollbars } from "react-custom-scrollbars";
import moment from "moment";
import { Button, Label } from "reactstrap";

import SideColumnWrapper from "../../../system/components/SideColumn";
import Toolbar from "../../../system/components/SideColumn/Toolbar";

const style = {
  padding: "15px"
};

const EditSideColumn = props => {
  const dateCreated = moment(props.created).format("DD / MM / YYYY");
  return (
    <SideColumnWrapper>
      <Toolbar>
        <Button
          color="success"
          disabled={props.loading}
          onClick={() => props.dispatch(submit("BlogForm"))}
        >
          Save
        </Button>

        {props.mode === "edit" && (
          <Button color="danger" outline onClick={() => props.remove()}>
            <i className="far fa-trash-alt" />
          </Button>
        )}

        <a href="/blogs">
          <Button color="primary" outline>
            <i className="far fa-list-alt" />
          </Button>
        </a>
      </Toolbar>

      {props.slug && (
        <div style={style} className="side-column-row">
          <Label>Slug</Label>
          <code>{props.slug}</code>
        </div>
      )}

      <div style={style} className="side-column-row">
        <Label>Created On</Label>
        {dateCreated}
      </div>

      <div style={style} className="side-column-row">
        <Label>Instructions</Label>
        <p>These are instructions</p>
      </div>

      {props.author && (
        <div style={style} className="side-column-row">
          <Label>Author</Label>
          {props.author.first_name} {props.author.last_name}
        </div>
      )}

      <Scrollbars />
    </SideColumnWrapper>
  );
};

export default connect()(EditSideColumn);



// WEBPACK FOOTER //
// ./src/containers/Blogs/components/EditSideColumn.jsx